import click from '@mailobj-browser/front/js/events/types/click.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { close } from '../../lightboxes/menus/menu.js'
import * as lightbox from '../../lightboxes/lightbox.js'
import ea_rte_exec_bkg from '../../ea/rte/ea_rte_exec_bkg.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: async (
    button
  ) => {
    const library = closest('[data-contract="menu.library"]', button)
    const origin = lightbox.opener(library)
    const form = closest('form', origin)
    const rte = one('iframe[data-rte]', form)

    if (rte && rte.id) {
      const { src } = one('img', button)
      const { dataset } = button.parentNode
      const { repeat, attach, position, color } = dataset

      await ea_rte_exec_bkg(rte.id, {
        link: src,
        repeat: repeat,
        attach: attach,
        pos: position,
        bkg: '',
        color: color,
        padding: ''
      })
    }

    close()
  }
})

export default button => {
  onClick.listen(button)
}

